import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import AuthenticationService from '@/lib/auth';
import { AuthenticationContextProvider } from './authentication.context';

export default function AuthenticationLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard if authenticated
    if (AuthenticationService.isAuthenticated) {
      navigate('/dashboard/organizations');
    }
  }, [navigate]);

  return (
    <AuthenticationContextProvider>
      <div className="flex justify-center items-center h-screen">
        <Card className="w-650 h-640 justify-center items-center">
          <CardHeader>
            <CardTitle>C8 Health Back-Office</CardTitle>
            <CardDescription>Sign In</CardDescription>
          </CardHeader>
          <CardContent>
            <Outlet />
          </CardContent>
        </Card>
      </div>
    </AuthenticationContextProvider>
  );
}
